import React, { useState, useRef, useEffect } from 'react';
import { VscClose } from 'react-icons/vsc';
import axios from "axios";
import { UNMNG_SCTR_GB_LIST } from "../../helper/SecurityHelper";

interface ComList {
  cmpnyNm: string;
  companyRegNum: string;
  representative: string;
  cmpnySeq: number;
  type: string;
  sctrGb: string;
}

export default function SearchCompany({ setTab, setCompanyName, setCompanyPopup, companyName, setCmpnySeq, setCmpnyType, auth, setAuth, selectedSctrGb, setSelectedSctrGb, setSnackbarTxt, nextHandler, tbmList }: any) {
  const [searchQuery, setSearchQuery] = useState(companyName);
  const [comList, setComList] = useState<ComList[]>();
  const [popupHeight, setPopupHeight] = useState('');
  const [popupMargin, setPopupMargin] = useState('');
  const comRefs = useRef({}) as React.MutableRefObject<any>;
  const [selectBtn, setSelectBtn] = useState(false);
  const [skipBtn, setSkipBtn] = useState(false);

  // useEffect(() => {if(comList?.length === 0) {setSkipBtn(true)}}, [comList])

  const fn_retrieveCmpnyList = async (nameOrRegNum: string) => {
    let paramAuth = auth;
    if(auth === 'WOK') {paramAuth = 'SRV'}
    let rtrnData = await axios.post('admin/api/cmpny/retrieveCmpnyList', { nameOrRegNum: nameOrRegNum, auth: paramAuth })

    setComList(rtrnData.data);
  }
  const searchHandler = async () => {
    if (searchQuery.length < 1) {
      setSnackbarTxt('검색할 업체명을 한글자 이상 입력해 주십시오.');
      return;
    }
    setCompanyName('');
    setSkipBtn(false);
    await fn_retrieveCmpnyList(searchQuery);

  };
  const selectHandler = (comName: any, cmpnySeq: any, type: string) => {
    if (companyName === comName) {
      comRefs.current[comName].style.borderColor = "#D9D9D9"
      comRefs.current[comName].style.color = "#B1B1b1"
      setSelectBtn(false);
      setCompanyName('');
      setCmpnySeq(null);
    } else {
      setSelectBtn(true);
      if (companyName !== '') {
        comRefs.current[companyName].style.borderColor = "#D9D9D9"
        comRefs.current[companyName].style.color = "#B1B1b1"
      }
      comRefs.current[comName].style.borderColor = "#00A0FD"
      comRefs.current[comName].style.color = "#353535"

      setCompanyName(comName);
      setCmpnySeq(cmpnySeq);
    }
  };

  const fn_skip = () => {
    if (!tbmList) {
      setAuth('WOK');
      setCmpnyType('');
    }
    setCompanyName('무소속');
    setCmpnySeq(null);
    if (tbmList) { setTab('exbtPlc') }
    setCompanyPopup(false);
  }

  const closeHandler = () => {
    setCompanyName('');
    setCmpnySeq(null);
    setCompanyPopup(false);
  }

  useEffect(() => {
    if (!comList) {
      setPopupHeight('w-[275px] sm:w-[308px] md:w-[750px] h-[240px] md:h-[600px] bg-white rounded-[5px] md:rounded-[12px] flex flex-col items-center')
    } else if (comList.length === 1 || comList.length === 0) {
      setPopupHeight('w-[275px] sm:w-[308px] md:w-[750px] h-[331px] md:h-[752px] bg-white rounded-[5px] md:rounded-[12px] flex flex-col items-center')
      setPopupMargin('w-[255px] sm:w-[274px] md:w-[685px] h-95 md:h-[187px] overflow-auto')
    } else if (comList.length > 1) {
      setPopupHeight('w-[275px] sm:w-[308px] md:w-[750px] h-[430px] md:h-[1000px] bg-white rounded-[5px] md:rounded-[12px] flex flex-col items-center')
      setPopupMargin('w-[275px] sm:w-[274px] md:w-[685px] h-185 md:h-[374px] overflow-auto mb-10 md:mb-[25px]')
    }
  }, [comList]);

  return (
    <div className='w-full h-[calc(100dvh)] absolute flex justify-center items-center bg-black bg-opacity-[70%] z-40 text-txtBlack'>
      <div className={popupHeight}>
        <div className='w-full h-44 md:h-[110px] bg-[#F5F5F5] flex justify-between items-center rounded-t-[5px] md:rounded-t-[12px]'>
          <p className='ml-20 text-15 md:ml-50 md:text-37 font-preBold'>업체 검색</p>
          <VscClose onClick={closeHandler} className='hover:cursor-pointer mr-15 text-22 md:mr-37 md:text-55' />
        </div>
        {!comList ? <> <p className='text-15 mt-25 md:text-37 md:mt-62'><span className='text-point'>소속된 업체명</span>을</p>
          <p className='text-15 mt-5 md:text-37 md:mt-12'>입력해주세요. (한 글자도 가능)</p> </>
            : comList.length > 0 ? <p className='text-15 mt-25 mb-10 md:text-37 md:mt-62'>하단에서 <span className='text-point'>업체</span>를 선택해 주세요.</p>
            : <> <p className='text-15 mt-25 md:text-37 md:mt-62'><span className='text-point'>소속된 업체명</span>을</p>
                 <p className='text-15 mt-5 md:text-37 md:mt-12'>입력해주세요. (한 글자도 가능)</p> </>}
        <input onChange={(e) => setSearchQuery(e.target.value)} type='text'
               className='w-[255px] sm:w-[274px] md:w-[685px] h-31 mt-15 mb-15 pl-7 md:h-[77px] md:mt-[37px] md:mb-[37px] md:pl-[17px] border border-[#D9D9D9] rounded-[5px] md:rounded-[12px] font-preLight md:text-35' />
        {comList &&
          <div className={popupMargin}>
            {comList.length > 0 ? comList.map((item, idx) => {
              return (
                <CompanyCard key={idx} selectHandler={selectHandler} comRef={comRefs} comName={item.cmpnyNm} comRegNum={item.companyRegNum} comRep={item.representative} cmpnySeq={item.cmpnySeq} type={item.type} sctrGb={item.sctrGb} />
              )
            }) : <p className={`text-15 leading-18 md:text-37 md:leading-45 font-preBold truncate`}>조회된 데이터가 없습니다.</p>
            }
          </div>}
        <div className='flex-column flex justify-center items-center' >
          <button onClick={selectBtn ? nextHandler : searchHandler} className='text-white text-17 md:text-37 font-preLight w-125 h-40 md:w-[222px] md:h-[100px] outline-none bg-gradient-to-r from-gdFrom to-gdTo rounded-[5px] md:rounded-[12px]'>{selectBtn ? '업체 선택 완료' : comList ? '다시검색' : '업체명 검색'}</button>
          {/*<button onClick={fn_skip} className='ml-10 text-17 md:ml-[25px] md:text-37 font-preLight w-125 h-40 md:w-[222px] md:h-[100px] outline-none text-[#E05185] border-[#E05185] border-2 rounded-[5px] md:rounded-[12px]'>업체명 모름</button>*/}
        </div>
      </div>
    </div>
  );
}

const CompanyCard = ({ selectHandler, comRef, comName, comRegNum, comRep, cmpnySeq, type, sctrGb }: any) => {
  let sctrGbNmList:string[] = [];
  let sctrGbNm = '';
  if (sctrGb && sctrGb !== '') {
    let sctrGbList = sctrGb.split(',');
    sctrGbList.map((sctrGb:any) => {
      if(sctrGb === '001'){sctrGbNm = '전시디자인설치'} else if(sctrGb === '002'){sctrGbNm = '전기시설'} else if(sctrGb === '003'){sctrGbNm = '급배수/압축'}
      else if(sctrGb === '004'){sctrGbNm = '광고사인물'} else if(sctrGb === '005'){sctrGbNm = '경비'} else if (sctrGb === '006'){sctrGbNm = '리깅'}
      else if(sctrGb === '007'){sctrGbNm = '가구비품'} else if(sctrGb === '008'){sctrGbNm = '지게차'} else if(sctrGb === '009'){sctrGbNm = '운수/통관'}
      else if(sctrGb === '010'){sctrGbNm = '카펫/파이텍스'} else if(sctrGb === '011'){sctrGbNm = '등록시스템'} else if(sctrGb === '012'){sctrGbNm = '철거'}
      else if(sctrGb === '013'){sctrGbNm = '목공조립식판넬'} else if(sctrGb === '014'){sctrGbNm = '구조해석'} else if(sctrGb === '015'){sctrGbNm = '도배'}
      else if(sctrGb === '016'){sctrGbNm = '방염'} else if(sctrGb === '017'){sctrGbNm = '기타'} else {sctrGbNm = ''}
      sctrGbNmList.push(sctrGbNm)})
    sctrGbNm = sctrGbNmList.join();
  }
  return (
    <div onClick={() => selectHandler(comName, cmpnySeq, type)} ref={(el) => comRef.current[comName] = el} className='flex flex-col justify-center w-full h-85 md:h-[175px] border border-[#D9D9D9] rounded-[5px] md:rounded-[12px] text-[#B1B1B1] pl-14 mb-5 md:pl-[35px] md:mb-[12px]'>
      <p className='text-17 md:text-35 font-preLight truncate'>{comName}</p>
      <p className='text-15 md:text-32 font-preLight'>{comRegNum} / {comRep}</p>
      {type === '002' && <p className='text-13 md:text-32 font-preLight truncate'>{sctrGbNm}</p> }
    </div>
  );
};
